/* global gsap */
import { useRef, useEffect } from 'react';

export default () => {
  const ref = useRef<HTMLElement>(null);
  const animation = useRef<GsapTimeline | null>(null);

  function animate() {
    return new Promise<void>((resolve, reject) => {
      if (animation.current) {
        animation.current.eventCallback('onComplete', resolve);
        gsap.set(ref.current, { transition: 'none' });
        animation.current.play();
      } else {
        reject();
      }
    });
  }

  useEffect(() => {
    animation.current = gsap.timeline({ paused: true });
    animation.current.to(ref.current, 0.4, { opacity: 0 });

    return () => {
      animation.current!.pause();
      animation.current!.kill();
      animation.current = null;
    };
  }, []);

  return [ref, animate] as const;
};
